import gql from "graphql-tag";

export default gql`
  query getTableUpdateTime($tables: [String!]!) {
    getTableUpdateTime(tables: $tables)
  }
`;
